import React from "react";

import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { MessageForm } from "../../Components/molecules/AuthForms/MessageForm";
import { FormItemsWrap } from "../../Components/molecules/Wrap/Wrap";

export const SuccessMessage = () => {
  const { t, i18n } = useTranslation(["glossary"]);
  //  Admin - Password reset already existing user
  return (
    <Stack
      style={{
        padding: "42px 38px",
      }}
    >
      <FormItemsWrap
        gap={"32px"}
        width={"398px"}
        justifyContent={"space-around"}
      >
        <MessageForm
          messageLineOne={t("glossary:auth.reset-password.reset-link")}
        />
      </FormItemsWrap>
    </Stack>
  );
};
